import { useContext, createContext } from 'react';

export const AgendaSidePanelInitialState = {
  isOpen: false,
  agendaText: '',
  agendaId: null,

  // for action items
  checkInInstanceId: null,
  checkInParentId: null,
  filterEmpIds: [],

  // closed count for side panel. we are using this to run effect whenever side panel is closed.
  closedCount: 0,
};

export const AgendaSidePanelContext = createContext(AgendaSidePanelInitialState);

export default function useAgendaSidePanelContext() {
  return useContext(AgendaSidePanelContext);
}
